import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Appointment } from 'src/app/core/models/appointment.model';
import { Linecard, LinecardElement } from 'src/app/core/models/linecard.model';
// tslint:disable-next-line: max-line-length
import { AppointmentLinecardCommentModalComponent } from '../appointment-linecard-comment-modal/appointment-linecard-comment-modal.component';

@Component({
	selector: 'app-appointment-linecard-list',
	templateUrl: './appointment-linecard-list.component.html',
	styleUrls: ['./appointment-linecard-list.component.scss']
})
export class AppointmentLinecardListComponent {

	pageTitle = 'Linecard';
	expandedSections = [];

	form: FormGroup;
	appointment: Appointment;

	details = [
		{ label: 'Linecard ID', field: 'linecardId' },
		{ label: 'Status', field: 'status' },
		{ label: 'Group ID', field: 'groupId' },
		{ label: 'Customer', field: 'customer' },
		{
			label: 'Customer Service',
			field: 'customerService',
			format: (strings: string[]) => {
				return (strings) ? strings.join('<br>') : '';
			}
		},
		{ label: 'Comment', field: 'comment' },
	];

	constructor(
		private formBuilder: FormBuilder,
		private modalController: ModalController,
	) { }

	get selectedLinecard() {
		return this.form.controls.linecard.value;
	}

	setAppointment(appointment: Appointment): void {
		if (!appointment) {
			return;
		}

		this.init(appointment);
	}

	private init(appointment: Appointment) {
		this.form = this.formBuilder.group({
			linecard: [(appointment.linecards[0] as Linecard), Validators.required],
		});

		this.appointment = appointment;
	}

	onChangeLinecard(): void {
		this.expandedSections = [];
	}

	async onClickAddChangeComment(linecardEl: LinecardElement): Promise<void> {
		const modal = await this.modalController.create({
			component: AppointmentLinecardCommentModalComponent,
			componentProps: {
				linecardEl,
				linecardDesc: (this.form.controls.linecard.value as Linecard).description,
				ticketId: this.appointment.ticketId,
			},
			cssClass: 'full-screen-modal',
		});

		await modal.present();
		await modal.onDidDismiss();
	}

	onClickToggleSection(index: number): void {
		const foundIndex = this.expandedSections.findIndex(i => i === index);
		if (foundIndex === -1) {
			this.expandedSections.push(index);
			return;
		}

		this.expandedSections.splice(foundIndex, 1);
	}

	isVisible(index: number): boolean {
		const foundIndex = this.expandedSections.findIndex(i => i === index);
		return foundIndex === -1 ? false : true;
	}

	compareWith(o1, o2): boolean {
		return o1 && o2 ? o1.linecardId === o2.linecardId : o1 === o2;
	}
}
